import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './LegalPage.css';

const legalContent = {
  terms: {
    title: 'Terms of Service',
    updated: 'Last updated: June 5, 2026',
    intro: 'These terms outline the basic expectations for using GLJewelAcademy services, courses, and website features.',
    sections: [
      {
        heading: 'Course Access',
        body: 'Course availability, enrollment details, schedules, and fees may change from time to time. Confirm current course information with GLJewelAcademy before enrolling.'
      },
      {
        heading: 'Account Responsibility',
        body: 'You are responsible for keeping your account details secure and for any activity that happens through your account.'
      },
      {
        heading: 'Learning Materials',
        body: 'Course content, images, videos, and learning materials are provided for personal education and may not be copied, redistributed, or resold without permission.'
      },
      {
        heading: 'Contact',
        body: 'For questions about these terms, contact GLJewelAcademy through the contact page.'
      }
    ]
  },
  privacy: {
    title: 'Privacy Policy',
    updated: 'Last updated: June 5, 2026',
    intro: 'This policy explains how GLJewelAcademy handles information submitted through this website.',
    sections: [
      {
        heading: 'Information We Collect',
        body: 'We may collect details such as your name, email address, phone number, account information, and messages you submit through forms.'
      },
      {
        heading: 'How We Use Information',
        body: 'We use submitted information to manage accounts, respond to enquiries, process course interest, and improve our student experience.'
      },
      {
        heading: 'Data Sharing',
        body: 'We do not sell your personal information. Information may be shared only when needed to provide services, comply with law, or protect the website.'
      },
      {
        heading: 'Contact',
        body: 'For privacy questions or data requests, contact GLJewelAcademy through the contact page.'
      }
    ]
  }
};

const LegalPage = ({ type }) => {
  const content = legalContent[type] || legalContent.terms;

  return (
    <main className="legal-page">
      <div className="container legal-container">
        <motion.div
          className="legal-header"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="legal-kicker">GLJewelAcademy</p>
          <h1>{content.title}</h1>
          <p className="legal-updated">{content.updated}</p>
          <p className="legal-intro">{content.intro}</p>
        </motion.div>

        <div className="legal-content">
          {content.sections.map((section) => (
            <section className="legal-section" key={section.heading}>
              <h2>{section.heading}</h2>
              <p>{section.body}</p>
            </section>
          ))}
        </div>

        <Link to="/contact" className="btn btn-primary legal-contact-link">
          Contact Us
        </Link>
      </div>
    </main>
  );
};

export default LegalPage;
